import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { TableRow, Link, Typography, TableCell } from '@mui/material';
import FinancedOffersPartnerItemLevelComponent from './FinancedOffersPartnerItemLevelComponent';
import { IconButton } from '@totalsoft/rocket-ui';
import { useContext } from 'react';
import { RightsContext } from 'providers/RightsContext';

export const FinancedOffersPartnerItemComponent = ({
  offerPartner,
  openFolder,
  openMasterPartner,
  openOfferClientQuestionnaire,
  masterPartnerApp,
  t,
  key
}) => {
  const { partnerQuestionnaireRead } = useContext(RightsContext);

  return (
    <>
      <TableRow key={key}>
        <TableCell>
          {masterPartnerApp ? (
            <Link onClick={openMasterPartner(offerPartner.masterPartnerId)}>{`${offerPartner.partnerName || ' '}`}</Link>
          ) : (
            <Typography>{`${offerPartner.partnerName || ' '}`}</Typography>
          )}
          {partnerQuestionnaireRead && (
            <IconButton
              onClick={openOfferClientQuestionnaire(
                offerPartner.offerId,
                offerPartner.offerSiteId,
                offerPartner.partnerId,
                offerPartner.partnerRole
              )}
              color='primary'
              variant='text'
              size='small'
              tooltip={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.Title')}
              id={'financedOffer_openOfferClientQuestionnaire'}
            >
              <QuestionAnswerIcon />
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          {`${
            offerPartner.partnerRole
              ? offerPartner.isRealBeneficiary
                ? `${offerPartner.partnerRole} - ${t('Folder.GeneralData.FinancedOffers.Partner.RealBeneficiary')} `
                : offerPartner.partnerRole
              : ' '
          } 
      ${offerPartner.shareholderLevel ? ' / ' + offerPartner.shareholderLevel + ' / ' : ''} `}
          <span>{offerPartner.shareholderLevel ? `${t('PERCENT_NUMBER', { number: offerPartner.percent || 0 })} %` : ''}</span>
        </TableCell>
        <TableCell>
          <Link onClick={openFolder(offerPartner.partnerFolderId, offerPartner.partnerFolderSiteId)}>
            {offerPartner.partnerFolderNumber || ' '}
          </Link>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={{ borderBottom: 'none' }}>
          <FinancedOffersPartnerItemLevelComponent
            identation={0.66}
            collection={offerPartner?.administrators}
            openMasterPartner={openMasterPartner}
            masterPartnerApp={masterPartnerApp}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ borderBottom: 'none' }}>
          <FinancedOffersPartnerItemLevelComponent
            identation={0.66}
            collection={offerPartner?.shareholders}
            hasNextLevel
            openMasterPartner={openMasterPartner}
            masterPartnerApp={masterPartnerApp}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

FinancedOffersPartnerItemComponent.propTypes = {
  offerPartner: PropTypes.object.isRequired,
  openFolder: PropTypes.func.isRequired,
  openMasterPartner: PropTypes.func.isRequired,
  openOfferClientQuestionnaire: PropTypes.func.isRequired,
  masterPartnerApp: PropTypes.bool,
  t: PropTypes.func.isRequired,
  key: PropTypes.number
};

export default compose(withTranslation())(FinancedOffersPartnerItemComponent);
